export default __webpack_public_path__ + "static/media/HotSale-Enova.ab2f9e9e.png";